import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

const http = axios.create({
	baseURL: '/wp-json/pem/'
});

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		user: false,
		courseId: document.getElementById('pem-course-id') ? document.getElementById('pem-course-id').getAttribute('data-id') : false,
		course: [],
		modules: [],
		answers: [],
		messages: {
			dashboard: [],
			sidebar: [],
			module: []
		},
		meta: {
			activeResourceIndex: 0
		},
		groupMeta: false,
		activeModule: {},
		activeModuleStats: {},
		activeResource: {},
		activeQuestions: {},
		loaded: {
			modules: false,
			groupMeta: false
		},
		isLoading: false,
		sidebar: 'login',
		content: 'intro-screen',
		passwordResetKey: ''
	},
	getters: {
		getNextResource(state) {
			for (var i in state.modules) {
				if (state.modules[i].module_id == state.activeModule) {
					for (var x in state.modules[i].resources) {
						var resource = state.modules[i].resources[x];
						if (resource.resource_id == state.activeResource) {
							if (state.modules[i].resources.length > x + 1) {
								return state.modules[i].resources[parseInt(x) + 1];
							}
						}
					}
				}
			}
			return false;
		},
		userIsGroupOwner(state) {
			for (var i in state.user.allcaps) {
				var cap = state.user.allcaps[i];
				if (i == 'pem_owner' && cap == true) {
					return true;
				}
			}
			return false;
		},
		myParameter(state) {
			return state.myParameter;
		},
		activeModules(state) {
			return state.myParameter;
		},
		finishedModules(state) {
			return state.myParameter;
		},
		getActiveModuleById(state) {
			if (!state.modules.length) {
				return false;
			}
			var activeModule = state.modules.filter((module) => module.module_id == state.activeModule);
			if (activeModule) {
				state.activeResource = activeModule[0].resources[0].resource_id;
				return activeModule[0];
			}
			return false;
		},
		getActiveResourceById(state) {
			for (var i in state.modules) {
				var activeResource = state.modules[i].resources.filter((resource) => resource.resource_id == state.activeResource);
				if (activeResource) {
					return activeResource[0];
				}
			}
			return false;
		},
		getAnswerByQuestionId: (state) => (id) => {
			return state.answers.find((answer) => answer.answer_id === id);
		}
	},
	mutations: {
		sidebar(state, payload) {
			state.sidebar = payload;
		},
		messages(state, payload) {
			state.messages = payload;
		},
		activeModule(state, payload) {
			state.activeModule = payload;
			state.activeResource = payload.resources[0];
			state.meta.activeResourceIndex = 0;
			state.content = 'module';
		},
		activeModuleStats(state, payload) {
			state.activeModuleStats = payload;
			state.content = 'moduleStats';
		}
	},
	actions: {
		goToDashboard({ state, dispatch }) {
			state.messages.dashboard = [];
			state.content = 'dashboard';
			state.activeModule = false;
			dispatch('scrollToAppTop');
		},
		dismissMessage({ commit, state }, payload) {
			for (var i in state.messages) {
				if (state.messages[i].text == payload) {
					state.messages.splice(i, 1);
				}
			}
		},
		doLogin({ commit, state, dispatch }, payload) {
			state.messages.sidebar = [];
			state.isLoading = true;
			http.post('user/login', {
				email: payload.email,
				password: payload.password
			})
				.then((response) => {
					state.isLoading = false;
					state.user = response.data.data.user;
					state.sidebar = 'logged-in';
					state.content = 'dashboard';
					dispatch('getCourseModules');
					/* Track in Google Analytics */
					__gaTracker('send', 'event', 'Målmedvetet näringsliv', 'login');
				})
				.catch((error) => {
					for (var i in error.response.data.data.messages) {
						state.messages.sidebar.push({
							text: error.response.data.data.messages[i],
							type: 'danger'
						});
					}
					state.isLoading = false;
				});
		},
		doLoginExistingUser({ commit, state, dispatch }, payload) {
			state.messages.sidebar = [];
			state.isLoading = true;
			http.get('user/loginExistingUser?_wpnonce=' + payload.nonce, {
				wp_nonce: payload.nonce
			})
				.then((response) => {
					state.isLoading = false;
					state.user = response.data.data.user;
					state.sidebar = 'logged-in';
					state.content = 'dashboard';
					dispatch('getCourseModules');
					/* Track in Google Analytics */
					__gaTracker('send', 'event', 'Målmedvetet näringsliv', 'login');
				})
				.catch((error) => {
					state.isLoading = false;
				});
		},
		doSignup({ commit, state, dispatch }, payload) {
			state.messages.sidebar = [];
			state.isLoading = true;
			http.post('user/signup', {
				email: payload.email,
				password: payload.password,
				user_role: payload.user_role,
				group_name: payload.group_name,
				company_name: payload.company_name,
				job_role: payload.job_role,
				group_key: payload.group_key,
				invitation_code: payload.invitation_code,
				privacy_policy: payload.privacy_policy
			})
				.then((response) => {
					/* Track in Google Analytics */
					__gaTracker('send', 'event', 'Målmedvetet näringsliv', 'signup', {
						hitCallback: function() {
							window.location.reload();
						}
					});

					/*
					state.user = response.data.data.user;
					state.sidebar = 'logged-in';
					state.content = 'dashboard';
					state.isLoading = false;
                    dispatch('getCourseModules');
                    */
				})
				.catch((error) => {
					console.log(error.response);
					if (error.response) {
						for (var i in error.response.data.data.messages) {
							state.messages.sidebar.push({
								text: error.response.data.data.messages[i],
								type: 'danger'
							});
						}
					}
					state.isLoading = false;
				});
		},
		doLogout({ commit, state, dispatch }) {
			state.user = false;
			state.sidebar = 'login';
			state.content = 'intro-screen';
			state.messages.sidebar = [
				{
					type: 'success',
					text: 'Du är utloggad'
				}
			];
			http.get('user/logout')
				.then((response) => {})
				.catch((error) => {});
		},
		getCourseModules({ state, dispatch }) {
			http({
				method: 'GET',
				headers: { 'X-WP-Nonce': state.user.nonce },
				url: `modules/getModulesByCourseId?courseId=${state.courseId}`
			})
				.then((response) => {
					state.modules = response.data.data.modules;
					state.loaded.modules = true;
					//dispatch('getAnswersForUser');
				})
				.catch((error) => {
					console.log(error.response);
				});
		},
		getCourseData({ state }) {
			http.get('course/getCourseData?courseId=' + state.courseId)
				.then((response) => {
					state.course = response.data.data.course;
				})
				.catch((error) => {
					console.log(error.response);
				});
		},
		doForgotPassword({ state }, payload) {
			state.isLoading = true;
			state.messages.sidebar = [];
			http.get('user/doForgotPassword?email=' + payload.email + '&url=' + window.location.href)
				.then((response) => {
					state.isLoading = false;
					state.sidebar = 'login';

					console.log(response);
					for (var i in response.data.data.messages) {
						state.messages.sidebar.push({
							text: response.data.data.messages[i],
							type: 'success'
						});
					}
				})
				.catch((error) => {
					state.isLoading = false;
					if (error.response) {
						for (var i in error.response.data.data.messages) {
							state.messages.sidebar.push({
								text: error.response.data.data.messages[i],
								type: 'danger'
							});
						}
					}
					console.log(error.response);
				});
		},
		doResetPassword({ state }, payload) {
			state.isLoading = true;
			state.messages.sidebar = [];
			http.get('user/doResetPassword?password=' + payload.password + '&passwordResetKey=' + state.passwordResetKey)
				.then((response) => {
					state.isLoading = false;
					state.sidebar = 'login';
					for (var i in response.data.data.messages) {
						state.messages.sidebar.push({
							text: response.data.data.messages[i],
							type: 'success'
						});
					}
				})
				.catch((error) => {
					state.isLoading = false;
					if (error.response) {
						for (var i in error.response.data.data.messages) {
							state.messages.sidebar.push({
								text: error.response.data.data.messages[i],
								type: 'danger'
							});
						}
					}
					console.log(error.response);
				});
		},
		saveResourceAnswers({ state, getters, dispatch }) {
			state.isLoading = true;
			state.messages.module = [];
			var answersToSubmit = [];
			for (var i in state.activeResource.questions) {
				var answer = state.activeResource.questions[i].user_answer;
				answer.resource_id = state.activeResource.resource_id;
				answersToSubmit.push(answer);
			}

			http({
				method: 'POST',
				headers: { 'X-WP-Nonce': state.user.nonce },
				data: {
					answers: answersToSubmit,
					course_id: state.courseId,
					group_id: state.user.group_id
				},
				url: 'answers/save'
			})
				.then((response) => {
					/*
					for (var i in response.data.data.messages) {
						state.messages.module.push({
							text: response.data.data.messages[i],
							type: 'success'
						});
                    }
                    */
					state.isLoading = false;
					__gaTracker({
						hitType: 'event',
						eventCategory: 'Målmedvetet näringsliv',
						eventAction: 'resource_completed',
						eventLabel: state.activeResource.resource_id
					});
					dispatch('goToNextResource');
					dispatch('scrollToAppTop');
				})
				.catch((error) => {
					console.log(error.response);
					for (var i in error.response.data.data.messages) {
						state.messages.module.push({
							text: error.response.data.data.messages[i],
							type: 'danger'
						});
					}
					state.isLoading = false;
				});
		},
		getAnswersForUser({ state }) {
			http({
				method: 'GET',
				headers: { 'X-WP-Nonce': state.user.nonce },
				url: 'answers/getAnswersForUser?courseId=' + state.courseId
			})
				.then((response) => {
					if (response.data.data.answers) {
						state.answers = response.data.data.answers;
					}
				})
				.catch((error) => {
					console.log(error.response);
					for (var i in error.response.data.data.messages) {
						state.messages.module.push({
							text: error.response.data.data.messages[i],
							type: 'danger'
						});
					}
				});
		},
		/* Get group metadata, e.g. the number of users in the group */
		getGroupMeta({ state }) {
			http({
				method: 'GET',
				headers: { 'X-WP-Nonce': state.user.nonce },
				url: 'groups/getGroupMeta?courseId=' + state.courseId
			})
				.then((response) => {
					state.loaded.groupMeta = true;
					if (response.data.data.group_meta) {
						state.groupMeta = response.data.data.group_meta;
					}
				})
				.catch((error) => {
					console.log(error.response);
				});
		},
		goToNextResource({ state }) {
			state.messages.dashboard = [];
			/* Go to the next resource, if it exists. Otherwise, go to the dashboard */
			var currentResourceIndex = false;
			for (var i in state.activeModule.resources) {
				if (state.activeModule.resources[i].resource_id == state.activeResource.resource_id) {
					currentResourceIndex = parseInt(i);
					break;
				}
			}
			var nextResourceIndex = currentResourceIndex + 1;
			if (state.activeModule.resources[nextResourceIndex] != undefined) {
				state.activeResource = state.activeModule.resources[nextResourceIndex];
				state.meta.activeResourceIndex = nextResourceIndex;
			} else {
				state.messages.dashboard.push({
					type: 'success',
					text: 'Du har avklarat modulen ' + state.activeModule.name + '!'
				});
				state.content = 'dashboard';
				__gaTracker({
					hitType: 'event',
					eventCategory: 'Målmedvetet näringsliv',
					eventAction: 'module_completed',
					eventLabel: state.activeModule.name
				});
			}
		},
		goToPreviousModule({ state }) {
			if (state.meta.activeResourceIndex > 0) {
				state.meta.activeResourceIndex--;
				state.activeResource = state.activeModule.resources[state.meta.activeResourceIndex];
			} else {
				state.content = 'dashboard';
			}
		},
		scrollTo(element) {
			var to = element.offsetTop;
			var duration = 250;
			var difference = to - element.scrollTop;
			var perTick = (difference / duration) * 10;

			setTimeout(function() {
				element.scrollTop = element.scrollTop + perTick;
				if (element.scrollTop === to) return;
				scrollTo(element, to, duration - 10);
			}, 10);
		},
		scrollToAppTop() {
			/*
			var element = document.getElementById('pem-course-app');
			window.scroll({
				behavior: 'smooth',
				left: 0,
				top: element.offsetTop
            });
            */
		},
		setCSSVariables({ dispatch }) {
			window.onresize = (event) => {
				dispatch('setCSSVariables');
			};
			var contentBox = document.querySelector('.content-area-wrapper .content-box-padding');
			if (contentBox) {
				document.documentElement.style.setProperty('--video-height', contentBox.clientWidth * 0.5625 + 'px');
			}
		}
	}
});
